// MB-I18N-3 — Bridge locale active pour les helpers module-level (formatage monétaire/nombre)
// qui ne peuvent pas utiliser le hook useLanguage(). Synchronisé par LanguageProvider.
import { DEFAULT_LOCALE } from './localesConfig';

let current = DEFAULT_LOCALE;

export const setActiveLocale = (locale) => { current = locale || DEFAULT_LOCALE; };
export const getActiveLocale = () => current;
